import React from "react";
import IDropdown from "./IDropdown";

import * as style from "./DropdownStyle.module.scss";
import classNames from "classnames";

export let dropdownSelectRef: React.RefObject<HTMLSelectElement>;
const Dropdown: React.SFC<IDropdown> = (props: IDropdown) => {
  dropdownSelectRef = React.createRef();

  const defaultLabel = "Select option";
  const defaultValue = "-default-";
  const initialValue =
    props.initialValue === defaultLabel ? defaultValue : props.initialValue;

  return (
    <div className={style.dropdownHolder}>
      <select
        className={classNames(style.dropdown, props.className)}
        onChange={(e) => props.update(e.target.value)}
        ref={dropdownSelectRef}
        data-cy="dropdown"
        value={initialValue || props.currency}
        disabled={props.data.length === 0}
      >
        {props.initialValue === defaultLabel && (
          <option key={defaultValue} disabled={true} value={defaultValue}>
            {props.initialValue}
          </option>
        )}
        {props.data.map((el) => {
          if (el.active === false) return;
          return (
            <option key={el.id} value={el.slug}>
              {el.name}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default Dropdown;
